import { render, staticRenderFns } from "./Players.vue?vue&type=template&id=c3592d3e&scoped=true"
import script from "./Players.vue?vue&type=script&lang=js"
export * from "./Players.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3592d3e",
  null
  
)

export default component.exports